/**
 * Dates de création / mise à jour des articles du Centre d'Aide (ISO YYYY-MM-DD).
 *
 * Source de vérité pour le tri et les badges « Nouveau » / « Mis à jour ».
 * Amorcé depuis l'historique git via scripts/seed-help-article-dates.js
 * (seuil 4 lignes pour distinguer une vraie MAJ d'un reformatage),
 * puis maintenu par le skill /doc-article (création → createdAt + updatedAt,
 * édition → updatedAt). Toute valeur peut être ajustée à la main.
 *
 * Un slug absent de cette table est simplement affiché sans date ni badge.
 */
const ARTICLE_DATES = {
  "offres-et-fonctionnalites": { "createdAt": "2026-09-22", "updatedAt": "2026-10-21" },
  "entrainement-observateurs": { "createdAt": "2026-09-08", "updatedAt": "2026-09-08" },
  "projets-bibliotheque-scientifique": { "createdAt": "2026-09-08", "updatedAt": "2026-09-08" },
  "projets-scientifiques": { "createdAt": "2026-10-21", "updatedAt": "2026-10-21" },
  "ajouter-animal": {
    "createdAt": "2026-03-01",
    "updatedAt": "2026-10-03"
  },
  "analyse-focale": {
    "createdAt": "2026-03-01",
    "updatedAt": "2026-10-04"
  },
  "analyse-multi-parametres": {
    "createdAt": "2026-05-28",
    "updatedAt": "2026-10-04"
  },
  "analyse-questionnaires": {
    "createdAt": "2026-03-01",
    "updatedAt": "2026-10-04"
  },
  "analyse-scan": {
    "createdAt": "2026-03-01",
    "updatedAt": "2026-10-04"
  },
  "analyser-enrichissements": {
    "createdAt": "2026-03-01",
    "updatedAt": "2026-10-04"
  },
  "campagnes-pedago-training": {
    "createdAt": "2026-03-01",
    "updatedAt": "2026-10-04"
  },
  "catalogue-enrichissements": {
    "createdAt": "2026-03-01",
    "updatedAt": "2026-10-04"
  },
  "concordance-inter-evaluateurs": {
    "createdAt": "2026-03-05",
    "updatedAt": "2026-10-04"
  },
  "configurer-rapport": {
    "createdAt": "2026-03-01",
    "updatedAt": "2026-09-08"
  },
  "contexte-collecte": {
    "createdAt": "2026-06-01",
    "updatedAt": "2026-06-01"
  },
  "creation-import-animaux": {
    "createdAt": "2026-03-01",
    "updatedAt": "2026-10-03"
  },
  "creer-campagne": {
    "createdAt": "2026-03-01",
    "updatedAt": "2026-10-04"
  },
  "creer-gerer-tournee": {
    "createdAt": "2026-03-01",
    "updatedAt": "2026-03-01"
  },
  "creer-grille-evaluation": {
    "createdAt": "2026-03-01",
    "updatedAt": "2026-09-08"
  },
  "doublons-animaux": {
    "createdAt": "2026-07-05",
    "updatedAt": "2026-07-05"
  },
  "entrainement-medical-training": {
    "createdAt": "2026-07-20",
    "updatedAt": "2026-10-25"
  },
  "evaluer-animaux": {
    "createdAt": "2026-03-01",
    "updatedAt": "2026-03-05"
  },
  "exporter-donnees-campagne": {
    "createdAt": "2026-03-01",
    "updatedAt": "2026-03-05"
  },
  "exporter-enrichissements": {
    "createdAt": "2026-03-01",
    "updatedAt": "2026-10-04"
  },
  "fiche-individu": {
    "createdAt": "2026-03-01",
    "updatedAt": "2026-09-28"
  },
  "gestion-compte": {
    "createdAt": "2026-03-01",
    "updatedAt": "2026-09-28"
  },
  "gestion-enclos": {
    "createdAt": "2026-03-01",
    "updatedAt": "2026-10-03"
  },
  "gestion-especes": {
    "createdAt": "2026-03-01",
    "updatedAt": "2026-10-03"
  },
  "gestion-prescriptions": {
    "createdAt": "2026-03-01",
    "updatedAt": "2026-11-04"
  },
  "gestion-taches": {
    "createdAt": "2026-03-01",
    "updatedAt": "2026-09-28"
  },
  "gestion-utilisateurs": {
    "createdAt": "2026-03-01",
    "updatedAt": "2026-10-04"
  },
  "logiques-traduction": {
    "createdAt": "2026-08-06",
    "updatedAt": "2026-08-06"
  },
  "suivi-bien-etre-objectifs-actions": {
    "createdAt": "2026-10-13",
    "updatedAt": "2026-10-13"
  },
  "groupes-evaluation": {
    "createdAt": "2026-03-01",
    "updatedAt": "2026-10-03"
  },
  "navigation-interface": {
    "createdAt": "2026-03-01",
    "updatedAt": "2026-09-08"
  },
  "notes-collaboration": {
    "createdAt": "2026-03-01",
    "updatedAt": "2026-09-28"
  },
  "demandes-reponse-sla": {
    "createdAt": "2026-07-05",
    "updatedAt": "2026-09-28"
  },
  "publier-informations": {
    "createdAt": "2026-07-08",
    "updatedAt": "2026-07-08"
  },
  "organisation-parc": {
    "createdAt": "2026-03-01",
    "updatedAt": "2026-10-03"
  },
  "outils-evaluation": {
    "createdAt": "2026-03-01",
    "updatedAt": "2026-10-04"
  },
  "meteo-du-parc": {
    "createdAt": "2026-07-09",
    "updatedAt": "2026-09-08"
  },
  "parametres-environnementaux": {
    "createdAt": "2026-03-01",
    "updatedAt": "2026-10-04"
  },
  "parametres-personnalises-partage": {
    "createdAt": "2026-06-01",
    "updatedAt": "2026-09-28"
  },
  "parametres-suivis-rapports": {
    "createdAt": "2026-05-26",
    "updatedAt": "2026-10-04"
  },
  "parametres-zoo": {
    "createdAt": "2026-03-01",
    "updatedAt": "2026-11-01"
  },
  "planifier-session": {
    "createdAt": "2026-03-01",
    "updatedAt": "2026-10-04"
  },
  "premiere-connexion": {
    "createdAt": "2026-03-01",
    "updatedAt": "2026-07-08"
  },
  "rafiki-assistant-ia": {
    "createdAt": "2026-03-01",
    "updatedAt": "2026-10-04"
  },
  "remplir-rapport-journalier": {
    "createdAt": "2026-03-01",
    "updatedAt": "2026-10-04"
  },
  "suivi-sante": {
    "createdAt": "2026-03-01",
    "updatedAt": "2026-11-01"
  },
  "suivre-campagne": {
    "createdAt": "2026-03-01",
    "updatedAt": "2026-03-05"
  },
  "synchro-zims": {
    "createdAt": "2026-03-01",
    "updatedAt": "2026-10-17"
  },
  "synthese-consolidee": {
    "createdAt": "2026-03-01",
    "updatedAt": "2026-10-04"
  },
  "taches-veterinaires": {
    "createdAt": "2026-03-01",
    "updatedAt": "2026-10-04"
  },
  "tickets-support": {
    "createdAt": "2026-03-01",
    "updatedAt": "2026-03-01"
  },
  "transfert-animaux": {
    "createdAt": "2026-03-01",
    "updatedAt": "2026-03-01"
  },
  "types-ordonnances": {
    "createdAt": "2026-10-14",
    "updatedAt": "2026-11-01"
  },
  "utiliser-tournee-mobile": {
    "createdAt": "2026-03-01",
    "updatedAt": "2026-07-08"
  },
  "visualiser-donnees-collectees": {
    "createdAt": "2026-03-05",
    "updatedAt": "2026-03-05"
  },
  "vue-live-timeline": {
    "createdAt": "2026-03-01",
    "updatedAt": "2026-10-04"
  },
  "badges-et-classement": {
    "createdAt": "2026-07-10",
    "updatedAt": "2026-07-10"
  },
  "guides-enrichissements": {
    "createdAt": "2026-07-20",
    "updatedAt": "2026-10-04"
  },
  "evaluation-rapide-individuelle": {
    "createdAt": "2026-07-20",
    "updatedAt": "2026-09-22"
  },
  "module-technique-maintenance": {
    "createdAt": "2026-08-07",
    "updatedAt": "2026-08-07"
  }
};

export default ARTICLE_DATES;
